import React, { useEffect, useMemo, useState } from "react";
import { useFormData } from "../context/FormDataContext";
import { getToken } from "../auth/authClient";
// === AUTO: blob preview helper (no token in URL) ===
async function fetchImageBlobUrl(path, apiFetchFn) {
  const res = await apiFetchFn(path, { method: "GET" });
  if (!res.ok) {
    const t = await res.text().catch(() => "");
    throw new Error(`Foto načtení selhalo (${res.status}): ${t || res.statusText}`);
  }
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}
// === /AUTO: blob preview helper ===

const inputStyle = { width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #444", outline: "none" };


const labelStyle = { fontSize: 13, fontWeight: 800, marginBottom: 6 };


const API_BASE_URL = (import.meta?.env?.VITE_API_BASE_URL || "").replace(/\/$/, "");


// === AUTO: apiFetch s Bearer tokenem (když je k dispozici) ===
async function apiFetch(path, opts = {}) {
  const base = (API_BASE_URL || "").replace(/\/$/, "");
  const url = String(path || "").startsWith("http") ? String(path) : `${base}${path}`;
  const token = getToken() || "";
const headers = new Headers(opts.headers || {});
  if (token && !headers.has("Authorization")) headers.set("Authorization", `Bearer ${token}`);
  return fetch(url, { ...opts, headers, credentials: "include" });
}
// === /AUTO: apiFetch ===

function safePart(s) {
  return String(s || "")
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9_-]+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export default function VypravitelForm() {
  
  

  function buildFotoPath(file) {
    if (!orderId || !file) return "";
    const qs = new URLSearchParams({ orderId: orderId, kategorie: "op_vypravitel", file: String(file) });
    return `/api/foto/file?${qs.toString()}`;
  }

  async function ensureBlob(fileKey, fileName) {
    if (!fileName) return;
    if (imgCache && imgCache[fileKey] && imgCache[fileKey].file === fileName && imgCache[fileKey].url) return;
    try {
      const path = buildFotoPath(fileName);
      const url = await fetchImageBlobUrl(path, apiFetch);
      setImgCache((prev) => ({ ...(prev || {}), [fileKey]: { file: fileName, url } }));
    } catch (e) {
      // necháme to tiché, jen do konzole
      console.warn("blob preview failed", e);
    }
  }

  



const [imgCache, setImgCache] = useState({});
const ctx = useFormData();  const v = (ctx?.formData?.vypravitel || {});
const formData = ctx?.formData || {};
  const setFormData = ctx?.setFormData;
  const setPath = ctx?.setPath;

  const vypravitel = formData?.vypravitel || {};

  const [busyPredni, setBusyPredni] = useState(false);
  const [busyZadni, setBusyZadni] = useState(false);
  const [err, setErr] = useState("");
  const [showKontakt, setShowKontakt] = useState(false);

  const orderId = useMemo(() => {
    // bezpečné fallbacky – ať to funguje i když se jmenuje jinak
    const raw =
      formData?.orderId ||
      formData?.currentOrderId ||
      formData?.zakazkaId ||
      formData?.id ||
      "";

    const oid = safePart(raw);
    return oid || "";
  }, [formData]);

    useEffect(() => {
        try {
          ensureBlob("op_predni", vypravitel?.opObjednavatele?.predni);
          ensureBlob("op_zadni", vypravitel?.opObjednavatele?.zadni);
        } catch {}
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [orderId, vypravitel?.opObjednavatele?.predni, vypravitel?.opObjednavatele?.zadni]);


  const update = (path, value) => {
    setErr("");
    if (typeof setPath === "function") return setPath(path, value);

    // fallback, kdyby setPath nebyl k dispozici
    if (typeof setFormData === "function") {
      const parts = String(path).split(".");
      setFormData((prev) => {
        const next = structuredClone(prev || {});
        let cur = next;
        for (let i = 0; i < parts.length - 1; i++) {
          cur[parts[i]] = cur[parts[i]] || {};
          cur = cur[parts[i]];
        }
        cur[parts[parts.length - 1]] = value;
        return next;
      });
    }
  };

  const uploadOP = async (file, side) => {
    if (!file) return;
    if (!orderId) {
      setErr("Nejdřív ulož zakázku (aby existovalo Zakázka ID). Pak jde nahrát OP.");
      return;
    }

    const fd = new FormData();
    fd.append("files", file);
    fd.append("orderId", orderId);
    fd.append("kategorie", "op_vypravitel");

    const r = await fetch(`${API_BASE_URL}/api/foto/upload`, {
      method: "POST",
      body: fd,
      // ⚠️ auth se typicky řeší přes cookie/JWT v apiFetch.
      // Pokud máš API chráněné Bearer tokenem v headeru, dej sem header.
      credentials: "include" });

    const j = await r.json().catch(() => ({}));
    if (!r.ok || !j?.ok) {
      throw new Error(j?.error || `Upload selhal (${r.status})`);
    }

    const saved = Array.isArray(j?.saved) ? j.saved[0] : null;
    const filename = saved?.file || null;

    update(`vypravitel.opObjednavatele.${side}`, filename);
  };

  const previewUrl = (file) => {
    if (!orderId || !file) return "";
    const qs = new URLSearchParams({
      orderId,
      kategorie: "op_vypravitel",
      file,
    });
    return `${API_BASE_URL}/api/foto/file?${qs.toString()}`;
  };

  return (
    <div style={{ maxWidth: 900 }}>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 12 }}>Vypravitel (Objednavatel)</h2>

      {err ? (
        <div style={{ padding: 10, border: "1px solid #f3c0c0", background: "#fff5f5", borderRadius: 10, marginBottom: 12 }}>
          ❗ {err}
        </div>
      ) : null}

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        <label>
          Jméno
          <input
            value={vypravitel?.jmeno || ""}
            onChange={(e) => update("vypravitel.jmeno", e.target.value)}
            style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
          />
        </label>

        <label>
          Příjmení
          <input
            value={vypravitel?.prijmeni || ""}
            onChange={(e) => update("vypravitel.prijmeni", e.target.value)}
            style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
          />
        </label>

        <label>
          Vztah
          <input
            value={vypravitel?.vztah || ""}
            onChange={(e) => update("vypravitel.vztah", e.target.value)}
            style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
          />
        </label>

        <label>
          Datum narození
          <input
            value={vypravitel?.datumNarozeni || ""}
            onChange={(e) => update("vypravitel.datumNarozeni", e.target.value)}
            placeholder="např. 01.01.1980"
            style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
          />
        </label>

        <label style={{ gridColumn: "1 / -1" }}>
          Adresa
          <input
            value={vypravitel?.adresa || ""}
            onChange={(e) => update("vypravitel.adresa", e.target.value)}
            style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
          />
        </label>


        <label style={{ gridColumn: "1 / -1" }}>
          Trvalé bydliště
          <input
            value={vypravitel?.trvaleBydliste || ""}
            onChange={(e) => update("vypravitel.trvaleBydliste", e.target.value)}
            placeholder="ulice, č.p., město, PSČ"
            style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
          />
        </label>

        <label style={{ gridColumn: "1 / -1" }}>
          Přechodné bydliště (volitelné)
          <input
            value={vypravitel?.prechodneBydliste || ""}
            onChange={(e) => update("vypravitel.prechodneBydliste", e.target.value)}
            placeholder="pokud je jiné než trvalé"
            style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
          />
        </label>

        <label>
          Telefon
          <input
            value={vypravitel?.telefon || ""}
            onChange={(e) => update("vypravitel.telefon", e.target.value)}
            style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
          />
        </label>

        <label>
          Email
          <input
            value={vypravitel?.email || ""}
            onChange={(e) => update("vypravitel.email", e.target.value)}
            style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
          />
        </label>

        <label>
          Státní příslušnost
          <input
            value={vypravitel?.statniPrislusnost || "ČR"}
            onChange={(e) => update("vypravitel.statniPrislusnost", e.target.value)}
            style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
          />
        </label>

        <div />
      </div>

      
      <div style={{ marginTop: 18, padding: 14, border: "1px solid #ddd", borderRadius: 14 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, marginBottom: 10 }}>
          <div style={{ fontWeight: 800 }}>Kontaktní osoba</div>
          <button
            type="button"
            onClick={() => setShowKontakt((v) => !v)}
            style={{
              padding: "8px 12px",
              borderRadius: 10,
              border: "1px solid #ddd",
              background: "#fff",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            {showKontakt ? "Skrýt" : "+ Přidat kontaktní osobu"}
          </button>
        </div>

        {showKontakt ? (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <label>
              Jméno
              <input
                value={vypravitel?.kontaktniOsoba?.jmeno || ""}
                onChange={(e) => update("vypravitel.kontaktniOsoba.jmeno", e.target.value)}
                style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
              />
            </label>

            <label>
              Příjmení
              <input
                value={vypravitel?.kontaktniOsoba?.prijmeni || ""}
                onChange={(e) => update("vypravitel.kontaktniOsoba.prijmeni", e.target.value)}
                style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
              />
            </label>

            <label>
              Role / vztah
              <input
                value={vypravitel?.kontaktniOsoba?.role || ""}
                onChange={(e) => update("vypravitel.kontaktniOsoba.role", e.target.value)}
                placeholder="např. dcera, syn, zmocněnec…"
                style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
              />
            </label>

            <label>
              Telefon
              <input
                value={vypravitel?.kontaktniOsoba?.telefon || ""}
                onChange={(e) => update("vypravitel.kontaktniOsoba.telefon", e.target.value)}
                style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
              />
            </label>

            <label>
              Email
              <input
                value={vypravitel?.kontaktniOsoba?.email || ""}
                onChange={(e) => update("vypravitel.kontaktniOsoba.email", e.target.value)}
                style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
              />
            </label>

            <label style={{ gridColumn: "1 / -1" }}>
              Adresa (volitelné)
              <input
                value={vypravitel?.kontaktniOsoba?.adresa || ""}
                onChange={(e) => update("vypravitel.kontaktniOsoba.adresa", e.target.value)}
                style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
              />
            </label>
          </div>
        ) : (
          <div style={{ fontSize: 13, opacity: 0.7 }}>
            Klikni na <b>+ Přidat kontaktní osobu</b> pro rozbalení polí.
          </div>
        )}
      </div>

      <div style={{ marginTop: 18, padding: 14, border: "1px solid #ddd", borderRadius: 14 }}>
        <div style={{ fontWeight: 700, marginBottom: 8 }}>OP objednavatele (pro matriku)</div>


        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
          {/* PŘEDNÍ */}
          <div>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>Přední strana</div>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              disabled={busyPredni}
              onChange={async (e) => {
                const f = e.target.files?.[0];
                if (!f) return;
                try {
                  setBusyPredni(true);
                  await uploadOP(f, "predni");
                } catch (ex) {
                  setErr(ex?.message || String(ex));
                } finally {
                  setBusyPredni(false);
                  e.target.value = "";
                }
              }}
            />
            {vypravitel?.opObjednavatele?.predni ? (
              <div style={{ marginTop: 8 }}>
                <img
                  src={previewUrl(vypravitel.opObjednavatele.predni)}
                  alt="OP přední"
                  style={{ width: "100%", maxHeight: 260, objectFit: "contain", borderRadius: 12, border: "1px solid #eee" }}
                />
                <div style={{ fontSize: 12, opacity: 0.8, marginTop: 4 }}>
                  Soubor: {vypravitel.opObjednavatele.predni}
                </div>
              </div>
            ) : (
              <div style={{ fontSize: 13, opacity: 0.7, marginTop: 6 }}>Zatím není nahráno.</div>
            )}
          </div>

          {/* ZADNÍ */}
          <div>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>Zadní strana</div>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              disabled={busyZadni}
              onChange={async (e) => {
                const f = e.target.files?.[0];
                if (!f) return;
                try {
                  setBusyZadni(true);
                  await uploadOP(f, "zadni");
                } catch (ex) {
                  setErr(ex?.message || String(ex));
                } finally {
                  setBusyZadni(false);
                  e.target.value = "";
                }
              }}
            />
            {vypravitel?.opObjednavatele?.zadni ? (
              <div style={{ marginTop: 8 }}>
                <img
                  src={previewUrl(vypravitel.opObjednavatele.zadni)}
                  alt="OP zadní"
                  style={{ width: "100%", maxHeight: 260, objectFit: "contain", borderRadius: 12, border: "1px solid #eee" }}
                />
                <div style={{ fontSize: 12, opacity: 0.8, marginTop: 4 }}>
                  Soubor: {vypravitel.opObjednavatele.zadni}
                </div>
              </div>
            ) : (
              <div style={{ fontSize: 13, opacity: 0.7, marginTop: 6 }}>Zatím není nahráno.</div>
            )}
          </div>
        </div>

        <div style={{ marginTop: 10, fontSize: 12, opacity: 0.75 }}>
          Kategorie uploadu: <b>op_vypravitel</b> • Zakázka ID: <b>{orderId || "—"}</b>
        </div>
      </div>
    
      {/* AUTO_KONTAKTNI_OSOBA_UI */}
      <details style={{ marginTop: 16, padding: 12, border: "1px solid #333", borderRadius: 12 }}>
        <summary style={{ cursor: "pointer", fontWeight: 900, fontSize: 16 }}>
          ➕ Kontaktní osoba (pokud nevyřizuje sám vypravitel)
        </summary>

        <div style={{ marginTop: 12, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div>
            <div style={labelStyle}>Jméno</div>
            <input
              style={inputStyle}
              value={vypravitel.kontaktniOsoba?.jmeno || ""}
              onChange={(e) => setPath("vypravitel.kontaktniOsoba.jmeno", e.target.value)}
            />
          </div>

          <div>
            <div style={labelStyle}>Příjmení</div>
            <input
              style={inputStyle}
              value={vypravitel.kontaktniOsoba?.prijmeni || ""}
              onChange={(e) => setPath("vypravitel.kontaktniOsoba.prijmeni", e.target.value)}
            />
          </div>

          <div>
            <div style={labelStyle}>Telefon</div>
            <input
              style={inputStyle}
              value={vypravitel.kontaktniOsoba?.telefon || ""}
              onChange={(e) => setPath("vypravitel.kontaktniOsoba.telefon", e.target.value)}
            />
          </div>

          <div>
            <div style={labelStyle}>E-mail</div>
            <input
              style={inputStyle}
              value={vypravitel.kontaktniOsoba?.email || ""}
              onChange={(e) => setPath("vypravitel.kontaktniOsoba.email", e.target.value)}
            />
          </div>

          <div style={{ gridColumn: "1 / -1" }}>
            <div style={labelStyle}>Trvalé bydliště</div>
            <input
              style={inputStyle}
              value={vypravitel.kontaktniOsoba?.trvaleBydliste || ""}
              onChange={(e) => setPath("vypravitel.kontaktniOsoba.trvaleBydliste", e.target.value)}
              placeholder="ulice, č.p., město, PSČ"
            />
          </div>

          <div style={{ gridColumn: "1 / -1" }}>
            <div style={labelStyle}>Přechodné bydliště (volitelné)</div>
            <input
              style={inputStyle}
              value={vypravitel.kontaktniOsoba?.prechodneBydliste || ""}
              onChange={(e) => setPath("vypravitel.kontaktniOsoba.prechodneBydliste", e.target.value)}
            />
          </div>
        </div>
      </details>

    </div>
  );
}
